import { render } from "./AtlasSignature.vue?vue&type=template&id=55c12c18&scoped=true"
import script from "./AtlasSignature.vue?vue&type=script&lang=js"
export * from "./AtlasSignature.vue?vue&type=script&lang=js"

import "./AtlasSignature.vue?vue&type=style&index=0&id=55c12c18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55c12c18"]])

export default __exports__